import { useSelector } from 'react-redux';
import { selectExperiments } from '../selectors/experiments';
import { getExperimentGroup } from '../utils/getExperimentGroup';

/**
 * @todo Удалить после завершения эксперимента
 * @description Данный функционал появился в задаче CD-253219, будет удалён в задаче CD-253242
 */
export const useExperimentGroup = (experiment: string) => {
  const experiments = useSelector(selectExperiments);
  const experimentGroup = getExperimentGroup(experiments, experiment);

  return experimentGroup !== 'A' ? experimentGroup : null;
};
